<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const active = ref(0)

const tabs = [
  { name: '首页', icon: 'home-o', path: '/' },
  { name: '教务成绩', icon: 'chart-trending-o', path: '/academic' },
  { name: '校园生活', icon: 'shop-o', path: '/campus' },
  { name: '个人中心', icon: 'manager-o', path: '/profile' },
]

// 根据当前路径设置激活索引
watch(
  () => route.path,
  (path) => {
    const index = tabs.findIndex((tab) => tab.path === path)
    if (index !== -1) active.value = index
  },
  { immediate: true },
)

function onChange(index: number) {
  active.value = index
  router.push(tabs[index].path)
}
</script>

<template>
  <van-tabbar
    v-model="active"
    :fixed="true"
    :border="true"
    :safe-area-inset-bottom="true"
    active-color="#3b5998"
    inactive-color="#999"
    @change="onChange"
  >
    <van-tabbar-item
      v-for="(tab, index) in tabs"
      :key="index"
      :icon="tab.icon"
    >
      {{ tab.name }}
    </van-tabbar-item>
  </van-tabbar>
</template>

<style lang="scss" scoped>
.van-tabbar {
  --van-tabbar-height: 50px;
}
</style>
